module.exports = __webpack_public_path__ + "static/media/banner1-julho2024-mobile.feb3d83b.jpg";